export default __webpack_public_path__ + "static/FeijoaWeb-MediumItalic-463387ef231b0bfa4214f8505ea0adfd.woff2";